import {GisMap} from "./gis-map";
import gisMapConfig from "./gis-map-config";
import {loadModules} from 'esri-loader';

let gisMap = null;
let devInWpGFForm = false;

window.gisAddonSearch = function(text) {
	if (gisMap !== null) {
		gisMap.searchLocation(text);
	}
};
const inDevMode = process.env.NODE_ENV !== 'production';

function setArcgisLoadingState(isLoading, message = 'Nacitavam mapove podklady...') {
	const container = document.querySelector('.gf-gis-addon-container');
	if (!container) {
		return;
	}

	let overlay = container.querySelector('.gf-gis-loader-overlay.global-loader');
	if (!overlay) {
		overlay = document.createElement('div');
		overlay.className = 'gf-gis-loader-overlay global-loader';
		overlay.innerHTML = '<div class="gf-gis-loader-spinner" aria-hidden="true"></div><div class="gf-gis-loader-text"></div>';
		container.appendChild(overlay);
	}

	const textEl = overlay.querySelector('.gf-gis-loader-text');
	if (textEl) {
		textEl.textContent = message;
	}

	overlay.style.display = isLoading ? 'flex' : 'none';
	container.classList.toggle('gf-gis-is-loading', isLoading);
}

if (inDevMode && !devInWpGFForm) { // in development mode
	console.log('GisMap is in development mode');
	window.addEventListener("DOMContentLoaded", () => {
		initializeMapApp();
	})

} else { // in production mode or devInWpGFForm true
	if (typeof jQuery !== "undefined") {
		jQuery(document).on('gform_post_render', function (event, form_id, current_page) {
			initializeMapApp();
		})
	}
}

function initializeMapApp() {
	const mapHostEl = document.getElementById('gf-gis-addon-argis-map');
	if (!mapHostEl) {
		setArcgisLoadingState(false);
		return;
	}

	if (gisMap === null) {
		const options = {version: '3.35', css: true};
		setArcgisLoadingState(true, 'Pripajam sa na ArcGIS sluzbu...');
		loadModules([
			"esri/map",
			"esri/toolbars/draw",
			"esri/toolbars/edit",
			"dojo/_base/event",
			"esri/graphic",
			"esri/symbols/SimpleMarkerSymbol",
			"esri/symbols/SimpleLineSymbol",
			"esri/symbols/SimpleFillSymbol",
			"esri/geometry/Extent",
			"esri/layers/TileInfo",
			"esri/SpatialReference",
			"esri/dijit/LayerList",
			"esri/dijit/Search",
			"esri/layers/OpenStreetMapLayer",
			"esri/layers/WMTSLayer",
			"esri/layers/WMTSLayerInfo",
			"esri/geometry/webMercatorUtils",
			"esri/geometry/geometryEngine",
			"esri/tasks/GeometryService",
			"esri/tasks/ProjectParameters",
			"esri/tasks/AreasAndLengthsParameters",
			"dojo/parser",
			"dijit/registry",
			"esri/graphicsUtils",
			"dojo/on",
			"esri/tasks/locator",
			"esri/layers/WMSLayer",
			"esri/layers/WMSLayerInfo",
			"esri/geometry/Polygon",
			'dojo/i18n!esri/nls/jsapi'
		], options)
			.then(([Map,
					   Draw,
					   Edit,
					   event,
					   Graphic,
					   SimpleMarkerSymbol,
					   SimpleLineSymbol,
					   SimpleFillSymbol,
					   Extent,
					   TileInfo,
					   SpatialReference,
					   LayerList,
					   Search,
					   OpenStreetMapLayer,
					   WMTSLayer,
					   WMTSLayerInfo,
					   webMercatorUtils,
					   geometryEngine,
					   GeometryService,
					   ProjectParameters,
					   AreasAndLengthsParameters,
					   parser,
					   registry,
					   graphicsUtils,
					   on,
					   Locator,
					   WMSLayer,
					   WMSLayerInfo,
					   Polygon,
					   bundle]) => {

				const arcGisModules = {
					Map,
					Draw,
					Edit,
					event,
					Graphic,
					SimpleMarkerSymbol,
					SimpleLineSymbol,
					SimpleFillSymbol,
					Extent,
					TileInfo,
					SpatialReference,
					LayerList,
					Search,
					OpenStreetMapLayer,
					WMTSLayer,
					WMTSLayerInfo,
					webMercatorUtils,
					geometryEngine,
					GeometryService,
					ProjectParameters,
					AreasAndLengthsParameters,
					parser,
					registry,
					graphicsUtils,
					on,
					Locator,
					WMSLayer,
					WMSLayerInfo,
					Polygon,
					bundle
				}
				//console.log('ArcGIS modules loaded');
				gisMap = new GisMap(gisMapConfig, arcGisModules);
				setArcgisLoadingState(false);
				//testExternalSearch()



			})
			.catch(err => {
				// handle any errors
				setArcgisLoadingState(false);
				console.log('ArcGIS / GisMap issue!');
				console.error(err);
				const connectionError = document.querySelector('.alert.alert-danger.arcgis-connection-error');
				if (connectionError) {
					connectionError.style.display = 'block';
				}
				const arcgisErrorEl = document.getElementById('gf-gis-addon-arcgis-error');
				if (arcgisErrorEl) {
					arcgisErrorEl.value = '1';
				}
			})

	} else {
		gisMap.init();
		//testExternalSearch()
	}

	function testExternalSearch() {
		const externalInput = document.getElementById('input_49_4')
		const searchInput = document.getElementById('search_input')
		if (externalInput) {
			externalInput.addEventListener("input", (event) => {

				console.log('change');
				searchInput.value = '';

				const minLat = 48.7873088282;
				const maxLat = 48.9061027920;
				const minLng = 19.7403666344;
				const maxLng = 19.7770049731;


				const cadastralBorderBR = `[[
					[${minLng}, ${minLat}],
					[${maxLng}, ${minLat}],
					[${maxLng}, ${maxLat}]
				]]`;

				gisMap.zoomToGraphics(cadastralBorderBR);

			})
		}
	}



}
